import React, { useState, useEffect } from "react";
import { getImageUrlAdminToken } from "../../utills/ImagesUtilsAdmin";
import {
  Table,
  TableBody,  
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddImage from "./AddImage";
import {
  fetchAllSpecialImages,
  deleteSpecialImage,
} from "../../services/specialImage";
import CustomSnackbar from "../../CustomSnackbar";

const NewImages = () => {
  const [showAddImage, setShowAddImage] = useState(false);
  const [editImageId, setEditImageId] = useState(null);
  const [image, setImage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");

 

  //------------------------------- Fetch all special images------------------------

  const fetchImages = async () => {
    try {
      const data = await fetchAllSpecialImages();
      setImage(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // --------------------------------------------deleteSpecialImage--------------------------------------
  const handleDeleteImage = async (id) => {
    try {
      await deleteSpecialImage(id);
      console.log("Image Deleted", id);
      setSnackbarOpen(true);
      setSnackbarMessage("Image Deleted Successfully");
      setSnackbarSeverity("success");
      fetchImages();
    } catch (error) {
      console.error("Error deleting image:", error);
      setSnackbarOpen(true);
      setSnackbarMessage("Error deleting image");
      setSnackbarSeverity("error");
    }
  };

// --------------------------------------handleAddImage--------------------------------------

  const handleAddImage = (newImage) => {
    // Handle adding new image logic here
    console.log("New Image Added", newImage);
    setShowAddImage(false);
    setEditImageId(null);
    fetchImages();
  };

  const handleEditImage = (id) => {
    setEditImageId(id);
    setShowAddImage(true);
  };

  return (
    <TableContainer component={Grid}>
      {showAddImage ? (
        <AddImage
          onAdd={handleAddImage}
          onBack={() => {
            setShowAddImage(false);
            setEditImageId(null);
          }}
          editImageId={editImageId}
        />
      ) : (
        <>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{ mb: 2 }}
            onClick={() => setShowAddImage(true)}
          >
            Add New Image
          </Button>
          {loading ? (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Table sx={{ minWidth: 650 }} aria-label="images table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ border: "1px solid lightgray" }}>
                    Title
                  </TableCell>
                  <TableCell sx={{ border: "1px solid lightgray" }}>
                    Thumbnail
                  </TableCell>
                  <TableCell sx={{ border: "1px solid lightgray" }}>
                    Alt Text
                  </TableCell>
                  <TableCell sx={{ border: "1px solid lightgray" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {image.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ border: "1px solid lightgray" }}
                    >
                      {row.image_title}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid lightgray" }}>
                      <Box
                        component="img"
                        sx={{
                          height: 100,
                          width: 100,
                          objectFit: "cover",
                          borderRadius: 1,
                        }}
                        alt={row.image_alt}
                        src={
                          row.image_thumbnail_url
                            ? getImageUrlAdminToken(row.image_thumbnail_url)
                            : "No Image"
                        }
                      />
                    </TableCell>
                    <TableCell sx={{ border: "1px solid lightgray" }}>
                      {row.image_alt}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid lightgray" }}>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          variant="contained"
                          color="warning"
                          onClick={() => handleEditImage(row.id)}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleDeleteImage(row.id)}
                        >
                          Delete
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </>
      )}
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </TableContainer>
  );
};

export default NewImages;
